<template>
  <div>
		This is the contact page
	</div>
</template>

<script>
export default {
  components: {},
  props: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>